var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" App下载页面 "),(_vm.phoneType === 'ios')?_c('base-open-app'):_vm._e(),(_vm.phoneType === 'android')?_c('base-open-app'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }